<!-- <form
  [formGroup]="loginForm"
  (ngSubmit)="loginUser()"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="10"
  class="login-form"
>
  <section fxLayout="row" fxLayoutAlign="start end">
    <img src="assets/img/grb.jpg" width="200" height="250" />
    <article fxLayout="column">
      <img src="assets/img/elab-logo.svg" />
      <span class="logo-title">MINISTARSTVO ZDRAVLJA REPUBLIKE SRBIJE</span>
    </article>
  </section>
  <mat-form-field appearance="fill" class="form-field">
    <mat-label>Korisničko ime</mat-label>
    <input matInput placeholder="Korisničko ime" formControlName="username" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="form-field">
    <mat-label>Lozinka</mat-label>
    <input
      matInput
      placeholder="Lozinka"
      formControlName="password"
      type="password"
    />
  </mat-form-field>

  <button mat-button color="primary" [disabled]="!this.loginForm.valid">
    PRIJAVA
  </button>
</form> -->

<section class="login-header">
  <section class="login-header-content">
    <img src="assets/img/ministarstvo-zdravlja-logo.svg" height="120px" />
  </section>
</section>

<section class="form-wrapper">
  <section fxLayout="row" fxLayoutAlign="start end">
    <article fxLayout="column">
      <img src="assets/img/elab-logo.svg" width="320px" />
    </article>
  </section>
  <form
    [formGroup]="loginForm"
    (ngSubmit)="loginUser()"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="login-form"
  >
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Korisničko ime</mat-label>
      <input matInput placeholder="Korisničko ime" formControlName="username" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Lozinka</mat-label>
      <input
        matInput
        placeholder="Lozinka"
        formControlName="password"
        type="password"
      />
    </mat-form-field>

    <button
      mat-button
      mat-flat-button
      color="primary"
      class="login-button"
      [disabled]="!this.loginForm.valid"
    >
      Prijava
    </button>
  </form>
</section>
